import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import Project from "../models/Project";

class ProjectManager extends ManagerBase {
	constructor () {
		super("projectManager");

		this.responsesModelClass = Project;
		this.remoteClassName = "project";
	}

	getByGuidList (guidList) {
		let rd = NousCore.api.createRequest({ filters: { guidList } });
		const requestedAction = "get-by-guid-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			// console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const projectList = Shark.getInstanceList(Project, data.items);

						return {
							data: projectList,
							status: "ok"
						};
					}
					default:
						return {
							data,
							status: "ok"
						};
				}
			}
		});
	}

	async getList (filters) {
		const result = await super.getList(filters.export());
		
		if (result.status === "ok") {
			Shark.set({
				projectList: result.data,
			});
			projectManager.emit("listChanged");
		}
		else {
			projectManager.emit("error", result);
		}
		
		return result;
	}

	async save (project) {
		var rd = NousCore.api.createRequest({ item: project.export() });
		const action = project.guid === "" ? "insert" : "update";

		return NousCore.api.send("project/" + action, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						project.import(data.items[0]);
						project.clean();
						
						if (action === "insert") {
							Shark.get("projectList").push(project);
						}

						projectManager.emit("saved");
						projectManager.emit("listChanged");
						return {
							data: project,
							requestedAction: action,
							status: "ok",
						};
					default:
						projectManager.emit("error", data.error);
						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}
}

const projectManager = new ProjectManager();

Shark.registerController(projectManager);

export default projectManager;